export default "https://cdn-static.gokick.com/assets/b96dd49a95534624185e45ca053b90dd739d9b4e/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";